export const validateEmail = (email: string) => {
    const regexEmail = new RegExp(
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );
    return regexEmail.test(email);
};

export const assertExhaustiveSwitch = <T = never>(value: NoInfer<T>) =>
    new Error(`assertExhaustiveSwitch: unexpected value ${value}`);
